export const QUERY_STOCK = `#graphql
  query GetProductStock($slugs: Slugs) {
    products(slugs: $slugs) {
    stock
    }
  }
`;

export const QUERY_PRODUCT_PAGES = `#graphql
  query GetProductPages($slugs: Slugs) {
    productPages(slugs: $slugs) {
      slug
      categoryHierarchy {
        lvl0
        lvl1
        lvl2
      }
      status
    }
  }  
`;

const reviewQuery = `#graphql
  sku
  content
  dateCreated
  rating
  reviewerName
  title
  reply
`;

const productChoiceQuery = `#graphql
  id
  title
  sku
  promocode
  url
  status
  slug
  categories
  categoryHierarchy {
    lvl0
    lvl1
    lvl2
  }
  description
  media {
    mainImage {
      url
      caption
      alttext
    }
    images {
      url
      caption
      alttext
    }
  }
  reviews {
    averageRating
    count
  }
  locations {
    name
    region
    lat
    lng
  }
  price {
    rrp
    currency
    percentOff
    fixedAmountOff
    displayPrice
  }
  info {
    whatsIncluded
    texts {
      name
      content
    }
  }
  numberOfPeople
  evoucherOnly
  suppliers {
    name
  }
  searchIndex
  stock
  deliveryOptions {
    sourceCode
    price
    name
    description
  }
  seo {
    title
    description
  }
  validity {
    validityMonths
    expiryDate
  }
  facets {
    features
    occasions
  }
`;

const productQuery = `#graphql
  id
  title
  sku
  promocode
  url
  status
  slug
  dateActivated
  isExclusive
  isCollectionProduct
  categories
  categoryHierarchy {
    lvl0
    lvl1
    lvl2
  }
  description
  media {
    mainImage {
      url
      caption
      alttext
    }
    images {
      url
      caption
      alttext
    }
    videos {
      url
      title
      featured
    }
  }
  reviews {
    averageRating
    count
  }
  locations {
    name
    region
    lat
    lng
  }
  price {
    rrp
    currency
    percentOff
    fixedAmountOff
    displayPrice
  }
  info {
    whatsIncluded
    texts {
      name
      content
    }
  }
  numberOfPeople
  evoucherOnly
  suppliers {
    name
  }
  searchIndex
  stock
  unitsAvailableIsPublic
  deliveryOptions {
    sourceCode
    price
    name
    description
  }
  seo {
    title
    description
  }
  validity {
    validityMonths
    expiryDate
  }
  facets {
    features
    occasions
  }
`;

const productAllQuery = `#graphql
  id
  title
  sku
  promocode
  url
  status
  slug
  isCollectionProduct
  dateActivated
  isExclusive
  productChoices {
    slug,
    title,
    mainImageUrl,
    mainImageAltText
  }
  categories
  categoryHierarchy {
    lvl0
    lvl1
    lvl2
  }
  description
  media {
    mainImage {
      url
      caption
      alttext
    }
    images {
      url
      caption
      alttext
    }
    videos {
      url
      title
      featured
    }
  }
  reviews {
    averageRating
    count
  }
  locations {
    name
    region
    lat
    lng
  }
  price {
    rrp
    currency
    percentOff
    fixedAmountOff
    displayPrice
  }
  info {
    whatsIncluded
    texts {
      name
      content
    }
  }
  numberOfPeople
  evoucherOnly
  suppliers {
    name
  }
  searchIndex
  stock
  unitsAvailableIsPublic
  deliveryOptions {
    sourceCode
    price
    name
    description
  }
  seo {
    title
    description
  }
  validity {
    validityMonths
    expiryDate
  }
  facets {
    features
    occasions
  }
`;
const vegCollectionQuery = `#graphql
  id
  title
  sku
  promocode
  url
  status
  slug
  isCollectionProduct
  productChoices {
    slug,
    title,
    mainImageUrl,
    mainImageAltText
  }
  categories
  categoryHierarchy {
    lvl0
    lvl1
    lvl2
  }
  media {
    mainImage {
      url
      caption
      alttext
    }
    images {
      url
      caption
      alttext
    }
  }
  reviews {
    averageRating
    count
  }
  price {
    rrp
    currency
    percentOff
    fixedAmountOff
    displayPrice
  }
  info {
    texts {
      name
      content
    }
  }
  numberOfPeople
  stock
  validity {
    validityMonths
    expiryDate
  }
`;

const vegProductQuery = `#graphql
  id
  title
  sku
  promocode
  url
  status
  slug
  isCollectionProduct
  categories
  categoryHierarchy {
    lvl0
    lvl1
    lvl2
  }
  description
  media {
    mainImage {
      url
      caption
      alttext
    }
    images {
      url
      caption
      alttext
    }
  }
  reviews {
    averageRating
    count
  }
  locations {
    name
    region
    lat
    lng
  }
  price {
    rrp
    currency
    percentOff
    fixedAmountOff
    displayPrice
  }
  info {
    whatsIncluded
    texts {
      name
      content
    }
  }
  numberOfPeople
  evoucherOnly
  suppliers {
    name
  }
  searchIndex
  stock
  deliveryOptions {
    sourceCode
    price
    name
    description
  }
  seo {
    title
    description
  }
  validity {
    validityMonths
    expiryDate
  }
  facets {
    features
    occasions
  }
`;

const productCardQuery = `#graphql
    id
    title
    slug
    url
    status
    sku
    promocode
    searchIndex
    dateActivated
    isExclusive
    media {
      mainImage {
      url
      alttext
      }
      images {
        url
        caption
        alttext
      }
    }
    price {
        rrp
        displayPrice
        fixedAmountOff
        percentOff
    }
    suppliers {
      name
    }
    categories
    categoryHierarchy {
      lvl0
      lvl1
      lvl2
    }
    isCollectionProduct
    locations {
      lat
      lng
      name
      region
    }
    reviews {
      averageRating
      count
    }
    facets {
      featureHierarchies {
        lvl0 
      }
      occasions
      occasionHierarchies {
        lvl1
      }
    }
`;

export const QUERY_PRODUCT_CARDS = `#graphql
query GetProductCards($productIds: Ids) {
  products(productIds: $productIds) {
    ${productCardQuery}
  }
}
`;

export const QUERY_TOP_PRODUCTS = `#graphql
query GetTopProducts($slugs: Slugs) {
  products(slugs: $slugs) {
    ${productCardQuery}
  }
}`;

export const QUERY_PDP_INFO = `#graphql
  query GetPDPInfo($productIds: Ids, $slugs: Slugs, $slug: String) {
    products(productIds: $productIds, slugs: $slugs) {
      ${productQuery}
    }
    reviews(slug: $slug) {
      ${reviewQuery}
    }
  }
`;

export const QUERY_COLLECTION_PDP_INFO = `#graphql
query GetCollectionPDPInfo($productIds: Ids, $slugs: Slugs) {
  products(productIds: $productIds, slugs: $slugs) {
    ${productAllQuery}
  }
}`;

export const QUERY_VEG_PDP_INFO = `#graphql
  query GetVegPDPInfo($productIds: Ids, $slugs: Slugs, $slug: String) {
    products(productIds: $productIds, slugs: $slugs) {
      ${vegProductQuery}
    }
    reviews(slug: $slug) {
      ${reviewQuery}
    }
  }
`;

export const QUERY_VEG_COLLECTION_PDP_INFO = `#graphql
query GetVegCollectionPDPInfo($productIds: Ids, $slugs: Slugs, $slug: String) {
  products(productIds: $productIds, slugs: $slugs) {
    ${vegCollectionQuery}
  }
  reviews(slug: $slug) {
    ${reviewQuery}
  }
}`;

export const QUERY_PRODUCT_CHOICE_INFO = `#graphql
  query GetProductChoiceInfo($productIds: Ids, $slugs: Slugs, $slug: String) {
    products(productIds: $productIds, slugs: $slugs) {
      ${productChoiceQuery}
    }
    reviews(slug: $slug) {
      ${reviewQuery}
    }
  }
`;

export const QUERY_PRODUCT_REVIEWS = `#graphql
  query GetProductReviews($slug: String) {
    reviews(slug: $slug) {
      ${reviewQuery}
    }
  }
`;

const blogQuery = `#graphql
  id
  title 
  sku
  url
  slug
  description
  shortDescription
  status
  media {
    mainImage {
      url
      caption
      alttext
    }
    images {
      url
      caption
      alttext
    }
  }
  reviews {
    averageRating
    count
  }
  price {
    rrp
    currency
    percentOff
    fixedAmountOff
    displayPrice
  }
  categories
  locations {
    lat
    lng
    name
    region
  }
  isCollectionProduct
`;

export const QUERY_BLOG_AUTHOR = `#graphql
  query GetBlogAuthorProductInfo($productIds: Ids) {
    products(productIds: $productIds) {
      ${blogQuery}
    }
  }
`;
export const QUERY_BLOG_CATEGORY = `#graphql
  query GetBlogCategoryProductInfo($productIds: Ids) {
    products(productIds: $productIds) {
      ${blogQuery}
    }
  }
`;
export const QUERY_BLOG_POST = `#graphql
  query GetBlogPostProductInfo($productIds: Ids) {
    products(productIds: $productIds) {
      ${blogQuery},
      categoryHierarchy {lvl0, lvl1, lvl2}
    }
  }
`;
export const QUERY_BLOG_HOME = `#graphql
  query GetBlogHomeProductInfo($productIds: Ids) {
    products(productIds: $productIds) {
      ${blogQuery}
    }
  }
`;
export const QUERY_TTD_POST = `#graphql
  query GetTTDPostProductInfo($productIds: Ids) {
    products(productIds: $productIds) {
      ${blogQuery},
      categoryHierarchy {lvl0, lvl1, lvl2}
    }
  }
`;
export const QUERY_TTD_HOME = `#graphql
  query GetTTDHomeProductInfo($productIds: Ids) {
    products(productIds: $productIds) {
      ${blogQuery}
    }
  }
`;

// ! this query is very resource intensive (~20-30 seconds / >40M)
// ! reconsider whether it is the right query for the job before using
export const QUERY_ALL_PDP_INFO = `#graphql
  query GetAllPDPInfo {
    products {
      ${productAllQuery}
    }
    
    reviews {
      ${reviewQuery}
    }
    
  }
`;

export default [
  QUERY_ALL_PDP_INFO,
  QUERY_PDP_INFO,
  QUERY_PRODUCT_REVIEWS,
  QUERY_STOCK,
  QUERY_PRODUCT_PAGES,
  QUERY_BLOG_AUTHOR,
  QUERY_BLOG_CATEGORY,
  QUERY_BLOG_POST,
  QUERY_BLOG_HOME,
  QUERY_TTD_POST,
  QUERY_TTD_HOME,
  QUERY_PRODUCT_CHOICE_INFO,
  QUERY_VEG_PDP_INFO,
  QUERY_VEG_COLLECTION_PDP_INFO,
];
